import { DocumentReference } from "@firebase/firestore-types";
import { Component } from "react";
import * as React from "react";
import { Glyphicon, Navbar } from "react-bootstrap";
import { NavLink, Redirect } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import AnnualSummaryByMonth from "src/components/projects/project/reports/annualsummary/AnnualSummaryByMonth";
import "src/css/components/projects/project/reports/annualsummary/annualsummarybymonth.css";
import { TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";
import { generateDualRateSummaryByMonth } from "./DualRateSummaryByMonth";
import {
  IAnnualSummaryByMonthReportPageProps,
  IAnnualSummaryByMonthReportPageState,
} from "./interfaces";
import { generateSingleRateSummaryByMonth } from "./SingleRateSummaryByMonth";

export default class AnnualSummaryByMonthReportPage extends Component<
  IAnnualSummaryByMonthReportPageProps,
  IAnnualSummaryByMonthReportPageState
> {
  public constructor(props: IAnnualSummaryByMonthReportPageProps) {
    super(props);

    this.state = {
      loading: true,
      annualSummaryByMonth: [],
      checkEstimatedGeneration: false,
    };

    this.renderNavbar = this.renderNavbar.bind(this);
    this.loadDualRateSummaryByMonth = this.loadDualRateSummaryByMonth.bind(this);
    this.loadSingleRateSummaryByMonth = this.loadSingleRateSummaryByMonth.bind(this);
  }

  public componentDidMount() {
    setTimeout(() => {
      const { appService } = this.props;
      const projectId = appService.getActiveProjectId();
      const projectDocument: DocumentReference = fs.fs.collection("projects").doc(projectId);
      projectDocument.get().then(doc => {
        if (doc.exists) {
          let { rateType, checkEstimatedGeneration } = doc.data() as any;
          if (!rateType) {
            rateType = 0;
          }
          if (checkEstimatedGeneration === undefined) {
            checkEstimatedGeneration = false;
          }
          if (rateType === 0) {
            this.loadSingleRateSummaryByMonth(checkEstimatedGeneration);
          } else if (rateType === 1) {
            this.loadDualRateSummaryByMonth(checkEstimatedGeneration);
          }
        }
      });
    }, TIMEOUT);
  }

  public render() {
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus text="Loading Table..." />;
    }

    return (
      <div className="statements-grid container-fixed-navbar">
        {this.renderNavbar()}
        <AnnualSummaryByMonth
          appService={this.props.appService}
          annualSummaryByMonth={this.state.annualSummaryByMonth}
          projectLocation={this.props.appService.getActiveProjectLocation()}
          checkEstimatedGeneration={this.state.checkEstimatedGeneration}
        />
      </div>
    );
  }

  private loadSingleRateSummaryByMonth(checkEstimatedGeneration: boolean): any {
    setTimeout(() => {
      const { appService } = this.props;
      const projectId = appService.getActiveProjectId();
      this.setState({ loading: true });
      generateSingleRateSummaryByMonth(projectId).then(annualSummaryByMonth => {
        setTimeout(() => {
          this.setState({ loading: false, annualSummaryByMonth, checkEstimatedGeneration });
        }, TIMEOUT);
      });
    }, TIMEOUT);
  }
  private loadDualRateSummaryByMonth(checkEstimatedGeneration: boolean): void {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.setState({ loading: true });
    generateDualRateSummaryByMonth(projectId).then(annualSummaryByMonth => {
      setTimeout(() => {
        this.setState({
          annualSummaryByMonth,
          checkEstimatedGeneration,
          loading: false,
        });
      }, TIMEOUT);
    });
  }

  private renderNavbar() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    const projectLocation = appService.getActiveProjectLocation();
    return (
      <div className="statement-navbar-container">
        <Navbar>
          <Navbar.Header>
            <Navbar.Brand>
              <NavLink to={`/project/${projectId}`}>
                <Glyphicon glyph="glyphicon glyphicon-circle-arrow-left" className="button-right" />
                Back to {projectLocation}
              </NavLink>
            </Navbar.Brand>
          </Navbar.Header>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/reports/AnnualSummaryByMonthReportPage.tsx